import { CSmartTable } from "@coreui/react-pro";
import React from "react";
import Card from "react-bootstrap/Card";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import EmptyCell from "../../components/emptyCell/emptyCell";

const ClubManagementComponent = (props) => {
  const { t } = useTranslation();
  const {
    smarttableref,
    columns,
    clubData,
    placeHolderShimer,
    onTableFilterChange,
    searchFilterClear,
    searchValue,
    dimensions,
    breadcrumbHeight,
    loading,
    tableContainerRef,
    loaderHtml,
    itemsPerPage,
    pageTitle,
    openCreateModal,
    createLoader,
    emptyImg,
  } = props;

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("CLUB_MANAGEMENT")} | RizzTix</title>
      </Helmet>
      <div className="pageContent categoryManagement">
        <div className="category">
          <Breadcrumbs
            innerPagetitle={t("CLUB_MANAGEMENT")}
            breadcrumbItem={t("CLUB_MANAGEMENT")}
            pageTitle={pageTitle}
            BreadcrumbInner={true}
            BreadcrumbmainTitle={true}
          />
          <Card className="mainCard mainCardWrapper">
            <Card.Body className="p-0 activeTab">
              <div className="mainCardBody">
                <div className="Card-Button d-flex flex-wrap gap-2 align-items-center">
                  <button
                    type="button"
                    className="btn-block btn btn-primary fillButton"
                    onClick={() => openCreateModal()}
                    disabled={createLoader}
                  >
                    <i className="bx bxs-plus-circle"></i>
                    {t("CLUB_ADD")}
                  </button>
                </div>
                <CSmartTable
                  ref={smarttableref}
                  cleaner
                  clickableRows={false}
                  columns={columns}
                  columnFilter={false}
                  items={clubData}
                  itemsPerPage={itemsPerPage}
                  pagination={false}
                  scopedColumns={{
                    name: (item) => (
                      <td>
                        <div className="tdWrapper">
                          {placeHolderShimer && <div className="shimer"></div>}
                          {item.name}
                        </div>
                      </td>
                    ),
                    slug: (item) => (
                      <td>
                        <div className="tdWrapper">
                          {placeHolderShimer && <div className="shimer"></div>}
                          <code>{item.slug}</code>
                        </div>
                      </td>
                    ),
                    isactive: (item) => (
                      <td>
                        <div className="tdWrapper">
                          {placeHolderShimer && <div className="shimer"></div>}
                          <span
                            className={
                              item.isactive !== false
                                ? "badge bg-success"
                                : "badge bg-secondary"
                            }
                          >
                            {item.isactive !== false
                              ? t("CLUB_STATUS_ACTIVE")
                              : t("CLUB_STATUS_INACTIVE")}
                          </span>
                        </div>
                      </td>
                    ),
                    branding: (item) => (
                      <td>
                        <div className="d-flex gap-1 align-items-center tdWrapper">
                          {placeHolderShimer && <div className="shimer"></div>}
                          <span
                            title={item.primarycolor}
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 4,
                              background: item.primarycolor || "#ccc",
                              border: "1px solid #ddd",
                            }}
                          />
                          <span
                            title={item.secondarycolor}
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 4,
                              background: item.secondarycolor || "#eee",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      </td>
                    ),
                    actions: (item) => (
                      <td>
                        <div className="actionWrapper d-flex gap-1 align-items-center">
                          {placeHolderShimer && <div className="shimer"></div>}
                          <Link
                            to={`/clubs-management/website/${item._id}`}
                            className="editButtton"
                            title={t("CLUB_WEBSITE_CUSTOMIZE_LINK")}
                          >
                            <i className="mdi mdi-pencil-outline font-size-24" />
                          </Link>
                          <Link
                            to={`/clubs-management/catalog/${item._id}`}
                            className="btn btn-sm btn-outline-light ms-1"
                            title={t("CATALOG_MANAGE_LINK")}
                          >
                            {t("CATALOG_ACTION_LABEL")}
                          </Link>
                        </div>
                      </td>
                    ),
                  }}
                  tableFilter
                  onTableFilterChange={onTableFilterChange}
                  tableFilterLabel={
                    searchValue?.length > 0 && (
                      <button
                        type="button"
                        onClick={searchFilterClear}
                        className="btn-close"
                      />
                    )
                  }
                  tableFilterPlaceholder={t("CLUB_SEARCH_PLACEHOLDER")}
                  tableProps={{
                    className: "mainTable",
                    responsive: true,
                    striped: false,
                    hover: false,
                  }}
                  noItemsLabel={
                    !placeHolderShimer && (
                      <EmptyCell
                        emptyItems={clubData}
                        noDataTitle={t("NO_DATA_FOUND")}
                        noDataAddButton={clubData?.length === 0}
                        noDataAddButtonTitle={t("CLUB_ADD")}
                        noDataDesc={t("CLUB_EMPTY_DESC")}
                        noDataDescTwo={t("CLUB_EMPTY_DESC")}
                        emptyDataAddButton={openCreateModal}
                        clearSearchButton={() => {}}
                        emptyImg={emptyImg}
                        emptyTitle={t("CLUB_EMPTY_TITLE")}
                        emptyDataDesc={t("CLUB_EMPTY_DESC")}
                        emptyDataDescTow={t("CLUB_EMPTY_DESC")}
                      />
                    )
                  }
                  tableBodyProps={{
                    className: "align-middle Table-Body-scroll",
                    style: {
                      height:
                        dimensions.width > 1279
                          ? dimensions.height -
                            breadcrumbHeight -
                            (loading && loaderHtml) -
                            250
                          : dimensions.height -
                            breadcrumbHeight -
                            (loading && loaderHtml) -
                            200,
                      overflowY: "auto",
                    },
                    ref: tableContainerRef,
                  }}
                />
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      {loading && <CustomLoadingHTML />}
    </React.Fragment>
  );
};

export default ClubManagementComponent;
